
const { document } = require('window');

const $ = require('jquery');
require('bootstrap');


const Dropdown = $.fn.dropdown.Constructor;


// data-API for dropdown dismissal
$(document).on('click.rgs-bs.dropdown.data-api', '[data-dismiss="dropdown"]', function () {
	const $dropdown = $(this).closest('.dropdown');
	const $toggle = $dropdown.find('[data-toggle="dropdown"]').first();
	if ($dropdown.is('.open')) {
		$toggle.dropdown('toggle');
	}
});


// animate.css transition on hide

// XXX: this should be at least less than or equal to @navbar-rgs-transition-duration
const TRANSITION_DURATION = 600;

$(document).on('hide.bs.dropdown.data-api.rgs-bs', '.dropdown', e => {
	if (!$.support.transition) {
		return;
	}

	if (e.isDefaultPrevented()) {
		return;
	}

	const $dropdown = $(e.target);
	const $menu = $dropdown.find('> .dropdown-menu').first();

	if ($dropdown.data('rgs-bs.dropdown.triggered-by-animation-end')) {
		$dropdown.data('rgs-bs.dropdown.triggered-by-animation-end', false);
		return;
	}

	const animation = $dropdown.attr('data-dropdown-hide-animation');

	if (!animation) {
		return;
	}

	e.preventDefault();

	const start = () => $menu.addClass(animation);

	let endCalled = false;

	const end = () => {
		if (endCalled) {
			return;
		}

		endCalled = true;

		$dropdown.data('rgs-bs.dropdown.triggered-by-animation-end', true);
		Dropdown.prototype.toggle.call(e.target, e);
		$menu.removeClass(animation);
	};

	start()
		.one($.support.transition.end, end)
		.one('bsTransitionEnd', end)
		.emulateTransitionEnd(TRANSITION_DURATION);
});
